/**
动态渲染组件

 */

export default {
  name: 'itemDynamic',
  props: {
    componentName: {
      type: String,
    },
    componentProps: {
      type: Object,
      default: () => {},
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    value: {
      default: null,
    },
  },
  data() {
    return {
      data: this.value,
    }
  },
  beforeDestroy() {
    this.data = null
  },
  methods: {},
  render(h) {
    this.componentProps.value = this.data
    this.componentProps.disabled = this.disabled
    var vNodeFn = h(this.componentName, {
      ref: 'itemDynamic',
      props: this.componentProps,
      on: {
        'on-blur': (val) => {
          this.$emit('on-blur')
        },
      },
      model: {
        value: this.data,
        callback: (val) => {
          this.$emit('on-change', val)
        },
      },
    })
    return vNodeFn
  },
}
